import app from 'flarum/forum/app';
import Api from '../utils/Api';
// v0.6.17a — 新建跟进 modal (辉哥 9/28 09:50 反馈: + 新建跟进 button 无 onclick handler)
import SalesFollowupCreateModal from '../modal/SalesFollowupCreateModal';
// v0.17.0 — 「体验详情」弹层 (辉哥 10/12 拍板)
import TrialDetailModal from '../modal/TrialDetailModal';
// v0.17.0 — 桌面「体验详情」图标按钮的 tooltip。
//   ⚠️ **必须手动 import Flarum 核心 Tooltip 组件**: `Button` 组件**没有** tooltip prop
//   (vendor/flarum/core/js/src/common/components/Button.tsx 全文零命中), 只有 Dropdown
//   集成了它。写 `title=` 属性只是浏览器原生提示, 不是 Flarum tooltip ——
//   验收口径是「tooltip 实际能显示」, 原生 title 不算数。
import Tooltip from 'flarum/common/components/Tooltip';
// v0.6.59 — 日期选择器公用 helper (辉哥 9/30 19:42 拍板: month mode 复用)
import { mountDatePicker } from '../utils/DatePickerHelper';
// v0.18.19 — 约课弹窗统一入口 (项目抽出来的 helper)。
//   ⚠️ 必须走它, 不要自己 app.modal.show(LessonEditorModal, …):
//   helper 内部有 setTimeout(0) + try/catch 的 mithril race 防护
//   (SOP 98: modal close 后立刻 reopen 偶发 instance 复用问题)。
import openBookingModal from '../utils/BookingModalHelper';
// v0.18.19 — toast 复用本仓既有 SlotContextMenu.toast()
//   (同 StudentsListTab.js:672 的用法; Flarum 2.0 前端没有 app.flash, 别自己造)
import SlotContextMenu from '../utils/SlotContextMenu';
// v0.18.69 (辉哥 10/23 拍板) — 「客户转学员」弹层 (独立组件, ⛔ 不塞进本文件)
import ConvertStudentModal from '../modal/ConvertStudentModal';
// 批 41 · 段① — 无限滚动 + IntersectionObserver 整套机制现在共用这个基类
//   (原来本文件抄了一份, LessonsTab / OperationLogsTab / StudentLessonsModal 各抄一份)
//   ⚠️ 本文件只需在 oninit 里给 this.sentinelAttr; 其余 (滚动根 / observer / 重试 / 翻页) 全在基类里。
import InfiniteScrollBase from '../utils/InfiniteScroll';
// v0.19.22 — 后端错误文案的**共用入口** (三级兜底 + 过滤 'null' / 'undefined' 占位串)
import { errReasonPlain } from '../utils/FormPrimitives';

/** 每页条数 —— 辉哥 10/13 拍板: 首屏 20 条, 往下滚动继续 20 条 (跟 OperationLogsTab.js:13 同值) */
const PAGE_SIZE = 20;

/**
 * sentinel 唯一 id 计数器 —— 照抄 OperationLogsTab.js:19 tabSeq 的做法,
 * 用来在 DOM 里认领「哪个 sentinel 是我的」, 避免抓到别的 tab 实例的 sentinel。
 */
let tabSeq = 0;
export default class SalesTab extends InfiniteScrollBase {
  oninit(vnode) {
    super.oninit(vnode);
    this.followups = [];
    // v0.6.17 — 月份选择 (辉哥 9/28 08:31 拍板 SalesTab 真数据化月选器: 默认本月)
    this.selectedMonth = this.defaultMonth();
    this.salesStats = null;
    this.statsLoading = false;
    // v0.5.5 — SalesTab 接 activeSchoolId
    this.activeSchoolId = vnode.attrs.activeSchoolId;
    // v0.18.69 — 「转学员」弹层要用**校区名** (设计稿分区①「校区」那一行) ⇒ 父组件把 schools 传下来。
    this.schools = vnode.attrs.schools || [];
    // v0.18.69 — 「查看学员」要跳到**学员列表** tab (带 ?highlight_student=) ⇒ 父组件给回调。
    this.onViewStudent = vnode.attrs.onViewStudent;
    // v0.6.16 — 跟踪哪些 mobile followup card 已展开
    this.expandedFollowups = new Set();
    // v0.18.20 (辉哥 10/19 拍板) — 「取消标记」的前值记忆 (id → 标记**之前**的 stage)。
    //   ⚠️ 为什么必须记前值而不是一刀切回 'contacted':
    //     一条本来是 booked (已约课) 的记录, 手滑标了「成交」,
    //     取消标记若打回 contacted, 「已约课」这个信息就丢了。
    //   ⚠️ 这是**内存态**: 刷新页面就没了 ⇒ 取消标记回落 DEFAULT_STAGE ('contacted',
    //     与后端 SalesFollowupValidator::DEFAULT_STAGE 一致)。
    this._prevStage = {};
    // v0.17.43 (辉哥 10/15 拍板方案 N) — 移动端数据面板折叠态。
    //   默认**收起** (辉哥硬要求), 只有用户手动点过才记住 —— 读一次就不写了,
    //   「读取」本身不产生存储副作用, 避免第一次进 tab 就把默认值写进 localStorage。
    this.dataPanelOpen = this.readDataPanelOpen();
    // v0.6.18 — 月份选择器 flatpickr 实例 (monthSelectorType dropdown, 任意年任意月)
    this._monthPickerFp = null;
    this._monthPickerRetry = 0;
    this._monthPickerTimer = null;
    // ── v0.17.20 分页状态 (跟 OperationLogsTab.js 同款命名, 方便两边对照) ──
    this.meta = null; // 后端汇总 (total / limit / offset / has_more)
    this.offset = 0; // 已加载条数 (= 下一批的 offset)
    this.reqSeq = 0; // 竞态守卫: 只有最新一次请求的结果算数
    this.paginatedOnce = false; // 是否翻过页 —— 决定要不要显示「已全部加载」
    this._observer = null; // IntersectionObserver 实例
    this._syncRaf = null; // 待执行的 rAF (syncObserver 重试), 关闭时要撤掉
    this._destroyed = false; // onremove 置 true —— 卸载后不再建 observer (防泄漏)
    this._sid = 'zsales' + ++tabSeq; // 本实例 sentinel 的 DOM 认领 id
    // 批 41 · 段① — 哨兵 DOM 属性名 (共用基类 utils/InfiniteScroll.js 按它认领 sentinel)
    this.sentinelAttr = 'data-zsalessid';
    this.load();
  }

  // v0.5.5 — 父组件异步换校区时, 同步 attrs + 重新 load
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (vnode.attrs.activeSchoolId !== this.activeSchoolId) {
      this.activeSchoolId = vnode.attrs.activeSchoolId;
      this.load();
    }
    // v0.18.69 — schools / onViewStudent 是**父组件后来给的** (schools 走接口异步回来,
    //   onViewStudent 是内联箭头函数 ⇒ 每次父组件渲染身份都变)。
    //   ⇒ 这里只做**赋值同步**, ⛔ 不触发任何请求/重绘 (父组件渲染时本来就会带着新值重画)。
    if (vnode.attrs.schools && vnode.attrs.schools !== this.schools) {
      this.schools = vnode.attrs.schools;
    }
    if (typeof vnode.attrs.onViewStudent === 'function') {
      this.onViewStudent = vnode.attrs.onViewStudent;
    }
  }

  // v0.6.18 — 月份选择器 flatpickr 初始化时机 (跟 CalendarTab.js:612 initDatePicker 同款)
  //   - oncreate: DOM 就绪后 setTimeout 0 再试 (flatpickr 全局 + input 都要 ready)
  //   - onupdate: view() 加载态返回 "加载中..." 时 input 还不存在, 有数据后 onupdate 补一次
  oncreate(vnode) {
    super.oncreate(vnode);
    setTimeout(() => this.initMonthPicker(), 0);
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.initMonthPicker();
  }
  onremove(vnode) {
    super.onremove(vnode);
    // ⚠️ v0.17.20 — 卸载标记。**必须**在 disconnect 之前置位:
    //   翻页请求可能在 tab 切走之后才回来, finally 里会调 syncObserver();
    //   没有这道闸, 它会给一个已经没人管的节点建 observer —— 那就是泄漏。
    this._destroyed = true;
    // ⚠️ v0.17.20 — 必须拆掉 IntersectionObserver。漏掉这里 = 每次切走这个 tab 泄漏一个 observer,
    //   observer 持有 sentinel 引用, sentinel 持有已经离屏的 DOM。
    this.disconnectObserver();
    // 撤掉排队中的重试帧 —— 否则 tab 切走了它还会醒来跑一次 syncObserver
    if (this._syncRaf) {
      cancelAnimationFrame(this._syncRaf);
      this._syncRaf = null;
    }
    if (this._monthPickerTimer) {
      clearTimeout(this._monthPickerTimer);
      this._monthPickerTimer = null;
    }
    if (this._monthPickerFp) {
      this._monthPickerFp.destroy();
      this._monthPickerFp = null;
    }
  }

  // v0.6.17 — 默认月份是当前年月 (YYYY-MM)
  defaultMonth() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  }
  async load() {
    // v0.6.17 — 并行 load stats + followups (保证 data 一致, single round-trip)
    // v0.17.20 — followups 改成「清空重取第 1 页」语义 (loadFollowups 现在就是 loadFirstPage)
    await Promise.all([this.loadStats(), this.loadFollowups()]);
  }
  async loadStats() {
    try {
      this.statsLoading = true;
      const params = {
        month: this.selectedMonth
      };
      if (this.activeSchoolId) params.school_id = this.activeSchoolId;
      this.salesStats = await Api.get('sales-stats', params);
    } catch (e) {
      console.error('load sales-stats failed', e);
      this.salesStats = null;
    } finally {
      this.statsLoading = false;
      m.redraw();
    }
  }

  /* ═══════════════ 数据加载 (v0.17.20 分页滚动加载) ═══════════════ */

  /**
   * 首屏 / 换月份 / 换校区: 清空重取 (offset 归零)
   *
   * ⚠️ 换月份**必须**走这里, 不能只改 this.selectedMonth 就发下一页请求 ——
   *   那会让新月份从旧 offset 继续取 (「9 月的第 3 页混进 10 月」的根因)。
   *   this.followups = [] 立即清空 ⇒ 切月份的瞬间屏幕上不留上一个月的行。
   *
   * ⚠️ 函数名保持 loadFollowups 不变: onbeforeupdate(换校区) 和新建跟进 modal 的
   *   onClose 回调都调它 —— 那两处要的就是「重新从头取」, 语义正好一致, 不必改调用方。
   */
  async loadFollowups() {
    this.followups = [];
    this.offset = 0;
    this.meta = null;
    this.paginatedOnce = false;
    this.loading = true;
    this.disconnectObserver();
    this.redraw();
    return this.fetchPage(0, 'replace');
  }

  /**
   * 拉一页。
   *
   * @param {number}  offset
   * @param {'replace'|'append'}  mode  replace=替换 (首屏/换筛选) / append=追加 (滚动)
   */
  async fetchPage(offset, mode) {
    // 每次请求领一个递增序号; 响应回来时序号不是最新的就**整个丢弃**。
    // 这是防串味的核心: 换月份时上一个月的请求还在路上, 它的响应必须被丢掉,
    // 否则那些行会被 concat 到新月份的批次尾巴上 (本 tab 天生就带月份筛选器, 这条必踩)。
    const seq = ++this.reqSeq;
    try {
      // ⚠️ 每批请求都带**完整**筛选参数 —— 前端不缓存任何筛选状态给后端猜。
      //   后端 total 与列表共用同一个 $scope 闭包, 筛选与 offset 是同一份口径。
      const params = {
        limit: PAGE_SIZE,
        offset: offset,
        month: this.selectedMonth
      };
      if (this.activeSchoolId) params.school_id = this.activeSchoolId;

      // v0.17.20 — 响应信封从裸数组改成 {data, meta} (端点全站只有本组件一个消费方)
      const res = await Api.get('sales-followups', params);
      // ★ 过期响应直接扔掉, 一个字段都不碰
      if (seq !== this.reqSeq) return;
      const rows = res && res.data || [];
      this.meta = res && res.meta || null;
      this.followups = mode === 'replace' ? rows : this.followups.concat(rows);
      // 下一批的 offset = 本批起点 + 本批实际行数 (用行数而不是 limit, 最后一页不满 20 时才对)
      this.offset = offset + rows.length;
      if (mode === 'append') this.paginatedOnce = true;
    } catch (e) {
      if (seq !== this.reqSeq) return;
      console.error('[zs] sales followups page load failed', e);
      if (mode === 'replace') this.followups = [];
    } finally {
      // ⚠️ 只有最新那次请求才允许改 loading 标志 —— 被丢弃的旧请求如果也去改,
      //    会把新一轮请求的 loading 提前清掉, 造成重复触发。
      if (seq === this.reqSeq) {
        this.loading = false;
        this.loadingMore = false;
      }
      this.redraw();
      this.syncObserver();
    }
  }

  /* ═══════════════ IntersectionObserver (现在共用 utils/InfiniteScroll.js) ═══════════════ */
  //
  //   findSentinel / findScrollRoot / disconnectObserver / syncObserver / scheduleSync / loadNextPage
  //   六个方法已挪到共用基类 utils/InfiniteScroll.js (批 41 · 段①)。
  //   三个坑 (滚动根误选 body / m.redraw 不同步 ⇒ observer 建不出来 / 孤儿 observer 泄漏)
  //   的实测根因注释全部随方法一起搬进了那个文件 —— 改滚动逻辑**只改那一处**。
  //
  //   本文件与滚动有关的私有数据只剩两个: this.sentinelAttr (见 oninit) + this._sid (DOM 认领 id)。

  /* ═══════════════ 汇总 (只读 meta) ═══════════════ */

  /** 该月份下的总条数 —— 一律读 meta.total, **不再**用 this.followups.length */
  totalCount() {
    return this.meta ? Number(this.meta.total) || 0 : 0;
  }
  redraw() {
    if (typeof m !== 'undefined' && m && typeof m.redraw === 'function') m.redraw();
  }
  formatStage(stage) {
    const map = {
      potential: {
        label: '潜在',
        class: 'gray'
      },
      contacted: {
        label: '已联系',
        class: 'blue'
      },
      booked: {
        label: '已约课',
        class: 'cyan'
      },
      trial: {
        label: '已试课',
        class: 'orange'
      },
      closed: {
        label: '已成交',
        class: 'green'
      },
      no_intent: {
        label: '无意向',
        class: 'red'
      }
    };
    return map[stage] || {
      label: stage,
      class: 'gray'
    };
  }

  /**
   * v0.16.0 — 来源渠道徽标配色 (描边风格, 跟阶段徽标的实心风格区分开,
   *   辉哥 10/10 设计稿 legend 明确要求: 「来源渠道徽标 新增 · 描边风格」)
   *   按渠道 id 前缀分色: builtin-walkin / -groundwork / -presale。
   *   自定义渠道没有语义前缀 → 统一走中性灰, 不硬套一个错误的颜色。
   */
  formatChannel(id, name) {
    if (!name) return null;
    let cls = 'ch-other';
    if (id === 'builtin-walkin') cls = 'ch-in';else if (id === 'builtin-groundwork') cls = 'ch-push';else if (id === 'builtin-presale') cls = 'ch-pre';
    return {
      label: name,
      class: cls
    };
  }

  /**
   * v0.16.10 — 年龄显示口径: **整数就显示整数, 真有小数位才显示小数**。
   *
   * ⚠️ 为什么不能直接渲染 f.age:
   *   后端列是 decimal(4,1), MySQL 会把 `34` 存成 `34.0`, 模型 `decimal:1` cast 又补齐 1 位,
   *   于是接口回来的是字符串 `"34.0"`。直接塞进 JSX, 列表上所有整数年龄都会变成 "34.0",
   *   比原来的 "34" 还难看。所以收口必须在这里做。
   *
   * ⚠️ 这里同样**绝不能**写成 `v || '—'`: 0 岁是合法客户, `(0 || '—')` 会显示成 '—'
   *   (所以第一行先显式判 null / undefined)。
   *
   * ⚠️ 为什么用 Math.round(n * 10) / 10 而不是直接 String(n):
   *   直接 String(7.4) 在部分浮点表示下会吐出 "7.4000000000000004" 这类尾数;
   *   先按「1 位小数的刻度」round 回 7.4 再转字符串, 结果稳定。
   *   同时顺带把 decimal 补出来的尾零去掉: 34.0 → "34" / 7.5 → "7.5" / 0.0 → "0"。
   */
  formatAge(v) {
    if (v === null || v === undefined || v === '') return '—';
    const n = Number(v);
    if (!isFinite(n)) return '—';
    return String(Math.round(n * 10) / 10);
  }

  /** v0.16.0 — 客户名: 自由输入的 customer_name 优先, 为空才回退到原学员名 (存量友好) */
  customerName(f) {
    const n = (f.customer_name || '').trim();
    if (n) return n;
    if (f.student && (f.student.display_name || f.student.username)) {
      return f.student.display_name || f.student.username;
    }
    return '—';
  }

  /** v0.16.0 — 姓名首字做头像占位 (设计稿 cust-av) */
  initial(name) {
    return name && name !== '—' ? name.slice(0, 1) : '?';
  }

  /* ── v0.16.11 销售跟进列表重设计 ─────────────────────────────────────
   *  移动端走方案 A「时间轴」, 桌面端走方案二「表格重构」。
   *  下面这几个 helper 是两端共用的「空值判断 + 紧迫度分档」,
   *  设计稿要求「空字段一律不渲染」(不再用 '—' 占位), 所以需要一个
   *  能把「空」和「0 / 7.5 这种合法值」分开的判断。
   */

  /** 空值判断: null / undefined / 空串 / 全空白字符串都算空。
   *  ⚠️ **绝不能**写 `!v`: 0 / '0' / 0.0 都是合法值, `!0` 为 true 会把
   *  「0 岁客户」当成「没填年龄」整段不渲染 —— 跟 formatAge() 注释里
   *  警告的是同一个坑, 这里再加一道同样的防线。 */
  isBlankVal(v) {
    return v === null || v === undefined || v === '' || String(v).trim() === '';
  }

  /** v0.16.11 — 年龄「空值版」: 空 → null, 其余一律委托 formatAge()。
   *  ⚠️ 绝不在这里重算年龄口径 —— 0 → '0' / 7.5 → '7.5' / 34.0 → '34'
   *  这些行为**全部**由 v0.16.10 的 formatAge() 说了算, 本函数只做
   *  「它说空就是空」这一个判断, 不重复实现 round 逻辑。
   *  formatAge() 空值返回 '—', 所以这里判 '—' 即为空。 */
  ageText(v) {
    const s = this.formatAge(v);
    return s === '—' || s === null || s === undefined || s === '' ? null : s;
  }

  /** v0.16.11 — 教练名「空值版」(空 → null), coachName() 的对应物。
   *  ⚠️ coach 是选填字段, 存量记录 coach_id 全是 NULL —— 所以「无教练」
   *  必须整段不渲染, 不能显示成 '教练 —'。 */
  coachText(f) {
    if (f.coach && (f.coach.display_name || f.coach.username)) {
      return f.coach.display_name || f.coach.username;
    }
    return null;
  }

  /**
   * v0.16.11 — 下次跟进紧迫度分档 (移动端时间轴 + 桌面端竖线共用)。
   *
   * ⚠️ 为什么不用 nextFollowup() 那套「soon」二元判断:
   *   设计稿要求 5 档视觉 + 5 档文案 (逾期/今天/明天/以后/未设),
   *   「soon」把 逾期 和 7 天内 塌成同一个布尔, 表达不了。
   *   nextFollowup() 保留原样并委托到这里 (见下), 不破坏既有调用方。
   *
   * ⚠️ 配色**刻意避开橙色** (辉哥 10/11 拍板):
   *   橙色在扩展里已被占用两处 —— 阶段「已试课」(.ZS-status-tag.orange)
   *   和渠道「地推」(.ZS-ch-tag.ch-push)。再拿橙色表示「今天」,
   *   一屏里橙色徽标和橙色日期会撞车, 销售要多看一个词才能区分。
   *   所以: 逾期=红 / 今天=黄 / 明天=浅灰 / 以后=灰 / 未设=虚线灰。
   * ⚠️ 颜色之外**永远伴随文字** (rel), 不靠颜色单独承载语义。
   */
  urgency(f) {
    // v0.19.10 — 已成交 / 无意向 ⇒ **不再显示任何跟进紧迫度** (含「逾期 N 天」)
    //
    //   根因: 后端 KPI 的「待跟进/逾期」早就 whereNotIn(stage, ['closed','no_intent'])
    //   (SalesStatsController v0.17.47 拍板) ⇒ 而前端 urgency() 压根不看 stage
    //   ⇒ 已成交 / 无意向的行照样红着「逾期 N 天」⇒ KPI 说 0 人、列表红着好几条 ⇒ 前后端口径打架。
    //   ⛔ 判定**只用** isMarkedStage() (v0.18.20 现成方法) —— 同一套口径, 不另写。
    if (this.isMarkedStage(f)) {
      // ⚠️ 文案**按 stage 分别取**: closed ⇒「已成交」/ no_intent ⇒「无意向」
      //   (辉哥 10/27 拍板: 「把『逾期x天』替换为已成交/无意向」)
      //   ⛔ **复用 formatStage().label** —— 阶段徽标 (ZS-status-tag) 用的是同一份映射
      //   ⇒ 文案只有一个真源, 以后改徽标文案这里自动跟着改, 不会两边打架。
      //   ⚠️ **只取 .label, ⛔ 不取 .class**: .class 是徽标配色 (closed=green / no_intent=red),
      //   跟进列**不要**跟着染红 —— 红色 = 告警, 正是这一批要消除的「假逾期」。
      //
      // v0.19.11 (辉哥 10/27 拍板) — 文案按 stage 分别取 + **各自上色** (绿/灰, = 徽标原色)
      //   closed ⇒ 「已成交」**绿** ; no_intent ⇒ 「无意向」**灰**
      //   ⛔ **不用红色**: 红色 = 告警, 批 30 刚把「假逾期」消掉, 不能再用红
      //   ⛔ 不用 formatStage().class (那是徽标配色, .red 其实已被覆写成灰) ⇒ 这里只取 .label
      //   k 分两档 (closed / no-intent) ⇒ LESS 才好分别上色
      //   ⚠️ **徽标已按 v0.19.11 去掉** (同一行原本出现两个「已成交」) ⇒ 阶段色由**这一列**承载,
      //     颜色 = 徽标原色 ⇒ 信息零损失。
      //
      // days=null ⇒ nextFollowup().soon 恒为 false ⇒ 老调用方不会把它当「7 天内到期」
      // date=文案 ⇒ **移动端与桌面端都不用改 JSX**:
      //   移动端 {u.date && <span className="d">{u.date}</span>} ⇒ 渲染文案
      //   桌面端 {u.date || '未设'} ⇒ 文案非空 ⇒ 不会退化成「未设」(那会自相矛盾)
      // rel='' ⇒ 不再有「逾期 N 天 / 今天跟进 / N 天后」任何一个紧迫度文案 (⛔ v0.19.10 行为不变)
      // ⚠️ date 位**不保留 MM-DD**: 已成交/无意向的记录压根没有「下次跟进」这回事,
      //   留着日期 = 谎报「这天还要跟进」⇒ 口径又要跟后端打架。
      const label = this.formatStage(f.stage).label;
      const k = f.stage === 'closed' ? 'closed' : 'no-intent';
      return {
        k: k,
        days: null,
        iso: '',
        date: label,
        rel: ''
      };
    }
    const raw = f.next_followup_at;
    if (this.isBlankVal(raw)) {
      return {
        k: 'none',
        days: null,
        iso: '',
        date: '',
        rel: '未设下次跟进'
      };
    }
    const iso = String(raw).slice(0, 10);
    // ⚠️ 按**自然日**算差值, 不按毫秒 (跟 nextFollowup() 原有口径一致):
    //   「距今 6 天 23 小时」到底算不算 7 天内, 用时刻相减会飘。
    const [y, m, day] = iso.split('-').map(Number);
    const today = new Date();
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
    const dueMidnight = new Date(y, (m || 1) - 1, day || 1).getTime();
    const days = Math.round((dueMidnight - todayMidnight) / 86400000);
    const mm = String(m || 0).padStart(2, '0');
    const dd = String(day || 0).padStart(2, '0');
    // 日期一律 MM-DD, 避免同一列里混「10月06日」和「2026-10-18」两种口径
    if (days < 0) return {
      k: 'overdue',
      days,
      iso,
      date: `${mm}-${dd}`,
      rel: `逾期 ${-days} 天`
    };
    if (days === 0) return {
      k: 'today',
      days,
      iso,
      date: '今天',
      rel: '今天跟进'
    };
    if (days === 1) return {
      k: 'tomorrow',
      days,
      iso,
      date: '明天',
      rel: '明天跟进'
    };
    return {
      k: 'later',
      days,
      iso,
      date: `${mm}-${dd}`,
      rel: `${days} 天后`
    };
  }
  isMobile() {
    return typeof window !== 'undefined' && window.innerWidth <= 640;
  }

  /* ══════════════════════════════════════════════════════════════════════
   * v0.17.43 (辉哥 10/15 拍板方案 N) — 移动端数据面板「可折叠」
   * ══════════════════════════════════════════════════════════════════════
   *
   * 【形态】收起态 = 一行紧凑摘要条 + 右侧 chevron; 展开态 = 完整 4 张 KPI 卡
   *   (2×2) + 完整 6 段漏斗。跟进记录区**永远不折叠**。
   *
   * 【为什么断点是 768 而不是 isMobile() 的 640】
   *   LESS 侧整块写在 @media (max-width: 768px) (跟 L4029 同一条带),
   *   JSX 若用 640 判定就会在 641~768 出现「JS 认为是桌面 / CSS 认为是移动」的错位:
   *   那一段本来就没有折叠条, 而 KPI 行又被 L4029 压死 —— 面板等于不存在。
   *   ⇒ JSX 阈值必须与 CSS media query 字面相同 (768), 两边不能各写各的。
   *   isMobile() 的 640 是「手机版式」阈值 (决定渲染卡片列表还是桌面表格), 与本条无关。
   *
   * 【桌面端为什么零影响】
   *   ≥769px 时本方法返回 false ⇒ view() 直接走老分支, **DOM 结构逐字节不变**,
   *   折叠条根本不渲染。LESS 侧另有 @media (min-width:769px) 把折叠条藏掉,
   *   兜住「不重绘就改窗口宽度」这一种错位 (窄屏加载后直接拉宽窗口)。
   */
  isPanelMode() {
    return typeof window !== 'undefined' && window.innerWidth <= 768;
  }

  /**
   * 折叠态存储 key —— **必须带 userId**。
   * 同设备换账号登录时若共用一个 key, A 用户的「展开」会漏给 B 用户。
   * 取不到用户 (未登录 / session 还没就绪) 落 'guest', 与设计稿一致。
   */
  dataPanelKey() {
    const u = app.session && app.session.user;
    let id = 'guest';
    try {
      if (u && u.id) id = String(u.id());
    } catch (e) {
      // id() 在 session 半就绪时可能抛 —— 静默落 guest, 不阻断渲染
    }
    return 'ziven-scheduler:tab6-data-panel:' + id;
  }

  /**
   * 读折叠态。**只有显式 '1' 才算展开**; 其余一切 (null / '' / '0' / 'true' /
   * 手工改坏的乱码 / 别的 key 串过来的值) 一律回落**收起**。
   * 整个读取包 try/catch: 隐私模式下 localStorage.getItem 本身就会抛
   * SecurityError, 抛出去会连带整个 tab 白屏。
   */
  readDataPanelOpen() {
    try {
      return window.localStorage.getItem(this.dataPanelKey()) === '1';
    } catch (e) {
      return false;
    }
  }

  /** 写折叠态。同样 try/catch —— 配额满 / 隐私模式只读时不能阻断交互。 */
  writeDataPanelOpen(open) {
    try {
      window.localStorage.setItem(this.dataPanelKey(), open ? '1' : '0');
    } catch (e) {
      // 存不进去只是「下次不记住」, 不该让点击没反应
    }
  }
  toggleDataPanel() {
    this.dataPanelOpen = !this.dataPanelOpen;
    this.writeDataPanelOpen(this.dataPanelOpen);
    this.redraw();
  }

  /**
   * v0.17.43 — 折叠条 (收起态唯一可见的东西)。
   *
   * ⚠️ 数据口径一个字没改: 本月销售额取 kpis.month_revenue, 待跟进取 kpis.pending,
   *    跟展开态那 4 张卡**同一个数据源**, 只是把其中两个数提到一行里。
   *    环比那行沿用 v0.17.40 定稿的 `{mr.change && …}` 机制 (后端没给就不渲染,
   *    不留空占位), 逾期数直接输出后端给的 `pending.overdue` 原文
   *    (SalesStatsController L313 输出的是 "N 已逾期"), 不在这里二次加工文案。
   */
  renderDataPanelStrip() {
    const k = this.salesStats?.kpis;
    const mr = k?.month_revenue;
    const pn = k?.pending;
    return m("div", {
      className: "ZS-stat-strip ZS-stat-strip-2",
      role: "button",
      tabIndex: 0,
      "aria-expanded": this.dataPanelOpen ? 'true' : 'false',
      "aria-label": "\u6570\u636E\u6982\u89C8",
      onclick: () => this.toggleDataPanel(),
      onkeydown: e => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          this.toggleDataPanel();
        }
      }
    }, m("span", {
      className: "ZS-strip-item"
    }, m("span", {
      className: "ZS-strip-k"
    }, "\u672C\u6708\u9500\u552E"), m("span", {
      className: "ZS-strip-v"
    }, mr?.value ?? '—'), mr?.change && m("span", {
      className: "ZS-strip-delta"
    }, mr.up ? '↑' : '↓', " ", mr.change)), m("span", {
      className: "ZS-strip-item"
    }, m("span", {
      className: "ZS-strip-k"
    }, "\u5F85\u8DDF\u8FDB"), m("span", {
      className: "ZS-strip-v"
    }, pn?.value ?? '—'), m("span", {
      className: "ZS-strip-v sub"
    }, pn?.overdue ?? '0 已逾期')), m("i", {
      className: "fas fa-chevron-down ZS-disclosure-caret",
      "aria-hidden": "true"
    }));
  }

  /**
   * v0.17.43 — 数据面板 (折叠条 + 展开体)。
   *
   * 折叠范围**只有**两样: KPI 行 + 移动端 .ZS-pipeline 漏斗。
   * 月份选择器与桌面 .ZS-funnel 都在面板外 —— 前者是控件不该被藏, 后者在
   * 641~768 段是唯一还看得见的漏斗 (那段渲染的是桌面分支), 收进面板等于
   * 「收起时把漏斗也藏了」, 与「跟进记录区永远不折叠」是同一条底线。
   *
   * 非面板模式 (≥769px) 直接把 KPI 行原样返回, 连 div 都不多包一层 ——
   * 桌面 DOM 与改动前完全一致, 不依赖「这个 div 恰好没有样式」这种巧合。
   */
  renderDataPanel() {
    if (!this.isPanelMode()) return this.renderKpis();
    const open = !!this.dataPanelOpen;
    return m("div", {
      className: 'ZS-data-panel' + (open ? ' ZS-data-panel-open' : '')
    }, this.renderDataPanelStrip(), m("div", {
      className: "ZS-disclosure-body"
    }, this.renderKpis(), this.isMobile() && this.renderPipeline(true)));
  }

  /**
   * v0.17.0 — 这一行是不是「体验归并」出来的跟进 (辉哥 10/12 拍板)
   *
   * ⚠️ 必须显式判 `=== 1` 而不是 `if (f.is_trial)`: 后端这一列是 tinyint NOT NULL,
   *   但**某些序列化路径下会是字符串 "0"** —— 而 JS 里 "0" 是 **truthy**,
   *   那样会让**每一条普通跟进**都冒出「体验详情」按钮和紫色「体验」徽标。
   *   用 Number() 归一, "0"/0 都落到 false。
   */
  isTrialRow(f) {
    return Number(f && f.is_trial) === 1;
  }

  /** v0.17.0 — 打开「体验详情」弹层 */
  openTrialDetail(f, e) {
    if (e) e.stopPropagation();
    // 用全局 app (本文件已有 `import app from 'flarum/forum/app'`), 与下面
    // 「新建跟进」按钮 (app.modal.show(SalesFollowupCreateModal, …)) 同款。
    // 写成 this.app.modal 在这里拿不到 app —— SalesTab 没有 this.app 这个属性,
    // 表现是**点击完全无反应**且控制台无报错 (最难查的那一类)。
    app.modal.show(TrialDetailModal, {
      followup: f
    });
  }

  /** v0.17.0 — 桌面: 紫色「体验详情」图标按钮 (Tooltip 来自 Flarum 核心) */
  renderTrialButtonDesktop(f) {
    if (!this.isTrialRow(f)) return null;
    return m(Tooltip, {
      text: "\u4F53\u9A8C\u8BE6\u60C5",
      position: "bottom"
    }, m("button", {
      className: "ZS-acts-trial",
      "aria-label": "\u4F53\u9A8C\u8BE6\u60C5",
      onclick: e => this.openTrialDetail(f, e)
    }, m("i", {
      className: "fas fa-clock-rotate-left"
    })));
  }

  /** v0.17.0 — 移动: 紫色文字按钮「体验详情」, 与既有 4 个动作并排 */
  renderTrialButtonMobile(f) {
    if (!this.isTrialRow(f)) return null;
    return m("button", {
      className: "ZS-fc-action trial",
      onclick: e => this.openTrialDetail(f, e)
    }, m("i", {
      className: "fas fa-clock-rotate-left"
    }), "\u4F53\u9A8C\u8BE6\u60C5");
  }

  /** v0.17.0 — 紫色「体验」徽标 (只挂在 is_trial=1 的行上, 普通跟进不泛紫) */
  renderTrialBadge(f) {
    if (!this.isTrialRow(f)) return null;
    return m("span", {
      className: "ZS-trial-badge"
    }, "\u4F53\u9A8C");
  }

  /**
   * v0.18.86 (P2-4) — **来源副标识** (同一条客户有多条记录时区分用)
   *
   * ## 现象
   *   销售先手建了一条跟进 (is_trial=0), 再约体验课 ⇒ 体验课按
   *   「同校区 + 同手机号 + is_trial=1」**另建一条** ⇒ 列表里两条同名同号,
   *   只靠一枚「体验」徽标区分 ⇒ 转学员时选错那条 ⇒ 体验卡一张都绑不上。
   *
   * ## 口径
   *   · **什么时候挂**: `same_phone_count > 1` (后端按「同校区 + 同号码」**全表**聚合,
   *     跨分页也准 —— 前端数本页的同号行数会漏判: 两条很可能不在同一页)。
   *   · **挂什么**:
   *       手建那条 (is_trial=0) ⇒ 「销售自建」
   *       体验那条 (is_trial=1) ⇒ 「体验课记录」
   *   · ⚠️ **两个标识互斥, 一行只挂一个** ⇒ 不会出现「两个标识打架」。
   *     优先级: **is_trial 优先** —— 一条跟进**既**是体验跟进**又**被销售改过阶段
   *     (stage 变成 closed / no_intent) 时, 它仍然是「体验课记录」:
   *     阶段说的是「销售跟到哪一步了」, 副标识说的是「这条记录**怎么来的**」,
   *     两件事互不覆盖 ⇒ 阶段那个签 (`ZS-status-tag`) 照旧显示, 不受影响。
   *   · ⛔ **只加标识**: 不改列结构、不改排序、不改筛选。
   */
  renderOriginBadge(f) {
    if (!f) return null;
    if (Number(f.same_phone_count) <= 1) return null;
    const isTrial = this.isTrialRow(f);
    return m("span", {
      className: 'ZS-sf-origin' + (isTrial ? ' is-trial' : '')
    }, isTrial ? '体验课记录' : '销售自建');
  }
  toggleFollowupExpand(id) {
    if (this.expandedFollowups.has(id)) {
      this.expandedFollowups.delete(id);
    } else {
      this.expandedFollowups.add(id);
    }
    m.redraw();
  }

  // v0.6.17a — 打开新建跟进 modal (辉哥 9/28 09:50 反馈修复 #1: button 加 click handler 弹 modal)
  // 关闭时调 onClose → 父组件 reload followups (新 card prepend 到列表顶部)
  openCreateFollowup() {
    app.modal.show(SalesFollowupCreateModal, {
      activeSchoolId: this.activeSchoolId,
      onClose: () => this.loadFollowups()
    });
  }

  /* ── v0.18.19 跟进记录动作: 预约 / 标记成交 / 标记流失 ──────────────────
   *
   * ⚠️ v0.18.19 之前, 这三个按钮的 onclick 写的是 `stop`, 而 `stop` 就是
   *   `(e) => { e.stopPropagation(); }` —— **只阻止冒泡, 什么都不做**。
   *   三枚按钮从来没接过任何逻辑 (纯占位), 后端其实早就支持改 stage
   *   (SalesFollowupValidator::STAGES 含 'closed' / 'no_intent')。
   */

  /**
   * v0.18.19 — 打开约课弹窗 (走项目统一入口, 不自己 new modal)
   *
   * ⚠️ LessonEditorModal **没有**「预填客户姓名/电话」的参数
   *   (只认 mode / lesson / start / end / room / scheduleNodeId / activeSchoolId / onClose),
   *   所以开**空白新建**约课弹窗即可 —— 要预填就得改 LessonEditorModal,
   *   那是另一个组件, 超出本轮范围。
   *
   * v0.18.38 (辉哥 10/20 亲口提的两条, 原话「从销售跟进tab中的跟进记录列表中,
   *   点击里面的『预约』按钮进入的约课modal, 要默认选择『体验课』。
   *   还有里面约课时间的日期选择器不应该是锁住的」):
   *
   *   - **defaultTab: 'trial'** —— 用户是从一条**销售线索**出发去约课的:
   *     这条线索还停在「已联系/待跟进」, 约的是**第一次上门的体验课**, 不是正课。
   *     ⇒ 打开就停在「体验课」tab, 少一次切 tab。
   *     (helper 那边默认是 'normal', 这里必须显式写 'trial' 才会切。)
   *   - **lockDate: false** —— 销售跟进里这条记录**没有**对应某个具体日期
   *     (不像 fc 课表入口是"点了某一格"进来的, 那一格的日期就是约课日期)。
   *     用户点「预约」时并没有指定哪天 ⇒ 日期**可以改**。
   *     (helper 那边默认是 true (锁死), 这里必须显式写 false 才会出现日期选择器。)
   *   - **activeSchoolId: this.activeSchoolId** —— ⛔ **必须传**, 不传这行这功能等于没交付:
   *     弹窗里 `this.activeSchoolId = vnode.attrs.activeSchoolId || null`, 而弹窗**没有**校区选择器
   *     (校区只能从 attrs 进来) ⇒ 不传就是 null ⇒ 三处硬伤:
   *       ① `loadTimeSchedule()` 第一行 `if (!this.activeSchoolId) return;` 直接早退
   *          ⇒ **时间段下拉永远停在「加载课表时间段中…」**, 用户连时间段都选不了;
   *       ② `trialValidate()` 最后一行 `if (!this.activeSchoolId) return '请先选择校区'`
   *          ⇒ **体验课存不进去**;
   *       ③ `validate()` 同样一句 ⇒ **正课也存不进去**;
   *       ④ `buildTrialPayload()` 的 `school_id: +this.activeSchoolId` 会是 **0** ⇒ 后端 422。
   *     ⇒ 这个入口的校区 id **就在手边** (`this.activeSchoolId`, SchedulerIndexPage 传进来的
   *       当前全局校区, L43 存下来的), 与 LessonsTab.openLessonEditor() / CalendarTab.openBooking()
   *       两个同款调用点的写法完全一致。
   *     ⚠️ v0.18.19 接上这个按钮时漏传了它 —— 本轮补上。
   *
   * @param {Event} [e] 原生事件 —— 移动端卡片整张可点(切展开), 必须挡住冒泡
   */
  openBookingFromSales(e) {
    if (e) e.stopPropagation();
    openBookingModal({
      mode: 'create',
      // v0.18.38 — 默认「体验课」tab + 日期可改 (理由见上方注释)
      defaultTab: 'trial',
      lockDate: false,
      // v0.18.38 — 校区 ID 必须传: 不传的话弹窗里 activeSchoolId=null,
      //   trialValidate()/validate() 的「请先选择校区」会把保存直接拦死 (存不进去)。
      activeSchoolId: this.activeSchoolId
    });
  }

  /**
   * v0.18.20 — 从异常里取一句**能给人看**的失败原因
   *
   * ⚠️ 后端抛 ValidationException 时 HTTP 422, 真实原因在 `err.response.errors[0].detail`;
   *   `err.message` 只是请求层的 "Response code 422 (Unprocessable Entity)"。
   * ⚠️ 网络层失败 (断网 / 请求被拦 / 超时) 时 mithril 给的 err.message 有时是**字符串 "null"** ——
   *   直接拼进 toast 会变成「标记失败: null」, 等于没提示 (实测: 拦掉 PATCH 就是这个)。
   *   ⇒ 把 "null" / "undefined" 这类占位串一律当「没有消息」, 回落成一句人话。
   */
  stageErrorMsg(err) {
    return errReasonPlain(err, '网络异常，请稍后重试');
  }

  /**
   * v0.18.19 — 改跟进阶段 (「标记成交」/「标记流失」共用)
   *
   * ⚠️ 移动端/桌面端的动作按钮都在**整行可点**的容器里 (移动端 .ZS-fc-card /
   *   桌面端 .ZS-table-row 都有 onclick 切展开), 所以必须 e.stopPropagation(),
   *   否则点「标记成交」会把卡片/行一起折叠掉。
   *
   * ⚠️ v0.18.20 (辉哥 10/19 反馈: 「标记之后不要刷新页面」) — 成功后**不再整体重载**。
   *   改前是 `await this.load()` → loadFollowups() 是「清空重取第 1 页」语义:
   *   this.followups = [] + this.loading = true + m.redraw() ⇒ 点一下按钮
   *   整个列表被清空、闪一下 loading、滚动位置跳回顶部。辉哥不接受。
   *   现在改成: ① 原地改这一条的 stage ② 只刷顶部漏斗 KPI ③ 重绘。
   *   ⛔ 绝对不要在这里调 this.load() / this.loadFollowups() —— 列表不能被清空。
   *
   * @param {object} f     跟进记录 —— 两处都是**按条渲染**, f.id 就是这条记录的 id
   * @param {string} stage  'closed' (已成交) | 'no_intent' (无意向)
   * @param {Event}  [e]
   */
  async setFollowupStage(f, stage, e) {
    if (e) e.stopPropagation();
    // v0.18.20 — 在**改之前**把当前这一档记进记忆, 「取消标记」靠它还原。
    //   (记的是「点标记之前的那一档」, 不是标记之后的目标 stage)
    const prevStage = f.stage;
    this._prevStage[f.id] = prevStage;
    try {
      // ⚠️ 走 Api.update, 别自己造请求: 它内部已处理
      //   「PATCH 被 app.request 改写成 POST」的坑 (走 window.m.request 兜底)。
      await Api.update('sales-followups', f.id, {
        stage: stage
      });
      // ① 原地改这一条的 stage —— f 就是 this.followups 数组里那个对象本身
      //   (渲染时 this.followups.map(f => …) 按条渲染), 改完徽标立刻变。
      f.stage = stage;
      SlotContextMenu.toast(stage === 'closed' ? '已标记为「已成交」' : '已标记为「无意向」', 'success');
      // ② 徽标立刻变 (不等 stats 请求回来)
      this.redraw();
      // ③ 只刷顶部漏斗 KPI —— 转化的 stage 计数变了, 数字必须跟上。
      //   ⚠️ loadStats() 会置 this.statsLoading, 但**本组件任何渲染路径都不读它**
      //     (只有 oninit/loadStats 三行在赋值, view/renderKpis 里零引用)
      //     ⇒ 不会闪 loading, 不需要额外抑制。
      await this.loadStats();
      // ④ KPI 数字到位后收尾重绘 (loadStats 的 finally 里已经 redraw 过一次, 这次兜底)
      this.redraw();
    } catch (err) {
      // ⚠️ 这次**没改成** ⇒ 记忆里不该留一个新值, 撤掉 (否则下次取消标记会还原错)
      if (this._prevStage[f.id] === prevStage) delete this._prevStage[f.id];
      console.error('[zs] sales followup stage update failed', err);
      // v0.17.65 统一后的取法: 后端抛 ValidationException 时 HTTP 422,
      //   真实原因在 `e.response.errors[0].detail`; `e.message` 只是请求层的
      //   "Response code 422 (Unprocessable Entity)", 跟后端那句提示无关。
      SlotContextMenu.toast('标记失败: ' + this.stageErrorMsg(err), 'error');
      // ⛔ 失败路径**不动列表** —— 不调 load()/loadFollowups(), 列表不闪 loading。
      this.redraw();
    }
  }

  /**
   * v0.18.20 (辉哥 10/19 拍板) — 「取消标记」: 把 stage 还原到**标记之前的那一档**
   *
   * ⚠️ 还原成前值, **不是**一刀切回 'contacted':
   *   一条本来是 booked (已约课) 的记录, 手滑标了「成交」,
   *   取消标记若打回 contacted, 「已约课」这个信息就丢了。
   *   记忆丢失 (页面刷新过 / 换了一条记录) ⇒ 回落 'contacted'
   *   (与后端 SalesFollowupValidator::DEFAULT_STAGE 一致)。
   *
   * ⚠️ 跟 setFollowupStage 同款约束: 成功后**只原地改 + 只刷 KPI**,
   *   ⛔ 不调 this.load() / this.loadFollowups() (列表会被清空 + 闪 loading)。
   */
  async undoFollowupStage(f, e) {
    if (e) e.stopPropagation();
    const target = this._prevStage[f.id] || 'contacted';
    try {
      await Api.update('sales-followups', f.id, {
        stage: target
      });
      // ① 原地改这一条的 stage (f 就是 this.followups 数组里那个对象)
      f.stage = target;
      // ② 记忆用完即弃 —— 下次再标记会重新记前值
      delete this._prevStage[f.id];
      SlotContextMenu.toast('已取消标记，恢复为「' + this.formatStage(target).label + '」', 'success');
      // ③ 徽标立刻变
      this.redraw();
      // ④ 只刷顶部漏斗 KPI
      await this.loadStats();
      this.redraw();
    } catch (err) {
      // ⚠️ 失败时**保留**记忆 (this._prevStage[f.id]) —— 用户重试还得还原到同一档
      console.error('[zs] sales followup stage undo failed', err);
      SlotContextMenu.toast('取消标记失败: ' + this.stageErrorMsg(err), 'error');
      this.redraw();
    }
  }

  /**
   * v0.18.20 — 这条记录是不是「已标记」态 (已成交 / 无意向)
   *
   * ⚠️ 判定**只看 f.stage**: 标记动作是就地改的 (不再重载列表),
   *    所以 f.stage 永远是这条记录当下的真值, 徽标和按钮都跟着它走。
   */
  isMarkedStage(f) {
    return f.stage === 'closed' || f.stage === 'no_intent';
  }

  /* ══════════════════════════════════════════════════════════════════════
   * v0.18.69 (辉哥 10/23 拍板) — 「客户转学员」
   * ══════════════════════════════════════════════════════════════════════ */

  /**
   * 当前 actor 有没有「管学员」的权限位?
   *
   * ⛔ **按权限决定有没有入口** (本仓既有约定): 没有 ⇒ **连按钮都不渲染**
   *   (不是「渲染了再拦」)。
   * ⛔ **不硬编码角色白名单** (比如「销售才能转」) —— 权限位后台可配,
   *   硬编码必不准。判据就是后端下发的 `canManageStudents`。
   */
  canManageStudents() {
    try {
      const user = app.session && app.session.user;
      if (!user) return false;
      const fn = user.canManageStudents;
      if (typeof fn !== 'function') return false;
      return !!fn.call(user);
    } catch (e) {
      // 取值 / 调用都可能抛 (attribute 未加载) ⇒ fail-closed: 不给入口
      return false;
    }
  }

  /** 这条跟进是不是「已转学员」? (判据是 converted_student_id, ⛔ 不是 stage) */
  isConverted(f) {
    return f && f.converted_student_id !== null && f.converted_student_id !== undefined && Number(f.converted_student_id) > 0;
  }

  /** 「转学员办卡」的显示条件: 已成交 **且** 还没转过 */
  canConvert(f) {
    return this.canManageStudents() && f && f.stage === 'closed' && !this.isConverted(f);
  }

  /**
   * 打开「转学员 · 办卡」弹层
   *
   * ⚠️ 弹层的**校区**用 `this.activeSchoolId` (当前校区) —— 与既有建卡端点
   *   强制 `active_school_id` 的行为一致 (brief §8 第 3 条: 弹层校区只读)。
   */
  openConvertStudent(f, e) {
    if (e) e.stopPropagation();
    app.modal.show(ConvertStudentModal, {
      followup: f,
      activeSchoolId: this.activeSchoolId,
      schools: this.schools || [],
      onConverted: res => this.onConverted(f, res)
    });
  }

  /**
   * 转学员成功后的处理 (辉哥 10/19 硬要求: **标记之后不要刷新页面**)
   *
   * ⚠️ 沿用 v0.18.20 的做法: ① 原地改这一条 ② 只刷顶部 KPI ③ 重绘。
   *   ⛔ **绝对不要**调 this.load() / this.loadFollowups() —— 列表会被清空 + 闪 loading。
   */
  async onConverted(f, res) {
    const username = res && res.username || '';
    const nickname = res && res.nickname || '';
    const tplName = res && res.card_template_name || '';
    const lessons = res && res.card_lessons || 0;

    // ① 原地改这一条 (f 就是 this.followups 数组里那个对象本身)
    f.converted_student_id = res && res.student_id ? Number(res.student_id) : null;
    f.trial_card = res && res.trial_card ? res.trial_card : null;
    // 登录名顺手存下来 —— 徽标/按钮立刻能显示 `已转学员 {username}`, ⛔ 不用等列表重载
    if (res && res.username) f.converted_student_username = res.username;

    // ② toast (文案照设计稿 S3)
    SlotContextMenu.toast('已转学员：' + username + '（' + nickname + '），已发卡「' + tplName + ' · ' + lessons + ' 课时」', 'success');

    // ③ 徽标 / 按钮立刻变 (不等 stats 请求回来)
    this.redraw();

    // ④ 只刷顶部 KPI (漏斗 / 待跟进) —— loadStats 的 finally 里已经 redraw 过一次
    await this.loadStats();
    this.redraw();
  }

  /**
   * 「查看学员 {username}」: 跳到 scheduler 的**学员列表** tab,
   * URL 带 `?highlight_student={student_id}` (学员列表读到该参数时一次性高亮)。
   *
   * ⚠️ 跳转由**父组件** (SchedulerIndexPage) 做 —— 它才有 tab 切换 + URL 的那套机制
   *   (本组件没有 selectTab)。本组件只负责把 student_id 交上去。
   */
  viewStudent(f, e) {
    if (e) e.stopPropagation();
    if (this.onViewStudent && f && f.converted_student_id) {
      this.onViewStudent(Number(f.converted_student_id));
    }
  }

  /** 桌面: 「转学员办卡」/「查看学员」按钮 (动作行第一枚) */
  renderConvertButtonDesktop(f) {
    if (this.canConvert(f)) {
      return m("button", {
        className: "a-primary",
        onclick: e => this.openConvertStudent(f, e)
      }, m("i", {
        className: "fas fa-user-plus"
      }), "\u8F6C\u5B66\u5458\u529E\u5361");
    }
    // ⚠️ 「查看学员」也按权限位收口: 它的**目标能力**是「学员列表」tab,
    //   而那个 tab 的门就是 `scheduler.manageStudents` (SchedulerIndexController::TAB_PERMISSIONS)
    //   ⇒ 没有该位的人点进去只会撞上「未开通排课权限」提示页 ⇒ **死链**, 不给入口。
    //   (辉哥 10/21 拍板: 「根据权限判断一下, 如果没有权限就没有跳转链接」)
    //   ⚠️ 但「已转学员 {username}」**徽标**照旧显示 (纯信息, 不跳任何地方)。
    if (this.isConverted(f) && this.canManageStudents()) {
      const u = this.convertedUsername(f);
      return m("button", {
        className: "a-book",
        onclick: e => this.viewStudent(f, e)
      }, m("i", {
        className: "fas fa-id-card"
      }), "\u67E5\u770B\u5B66\u5458 ", u);
    }
    return null;
  }

  /** 移动: 同款两枚按钮 (移动端动作行第一枚) */
  renderConvertButtonMobile(f) {
    if (this.canConvert(f)) {
      return m("button", {
        className: "ZS-fc-action zsc-primary",
        onclick: e => this.openConvertStudent(f, e)
      }, m("i", {
        className: "fas fa-user-plus"
      }), "\u8F6C\u5B66\u5458\u529E\u5361");
    }
    // ⚠️ 同上: 「查看学员」按 manageStudents 收口 (死链不给入口)
    if (this.isConverted(f) && this.canManageStudents()) {
      const u = this.convertedUsername(f);
      return m("button", {
        className: "ZS-fc-action",
        onclick: e => this.viewStudent(f, e)
      }, m("i", {
        className: "fas fa-id-card"
      }), "\u67E5\u770B\u5B66\u5458 ", u);
    }
    return null;
  }

  /** 已转学员的用户名 (徽标 / 按钮文案用) */
  convertedUsername(f) {
    if (!f) return '';
    // ① 后端直接下发 (v0.18.69: `converted_student_username`) —— 最准, ⛔ 不依赖前端 store
    if (f.converted_student_username) return String(f.converted_student_username);
    // ② 退到 app.store 反查 (学员可能已经在 store 里了)
    const id = Number(f.converted_student_id);
    const s = app.store && app.store.getById ? app.store.getById('users', id) : null;
    if (s && (s.username || s.nickname)) return s.username || s.nickname;
    // ③ 最后退到 #id (⛔ 绝不显示 undefined)
    return '#' + id;
  }

  /** 「已转学员 {username}」徽标 (客户名右侧) */
  renderConvertedBadge(f) {
    if (!this.isConverted(f)) return null;
    return m("span", {
      className: "ZS-converted-badge"
    }, "\u5DF2\u8F6C\u5B66\u5458 ", this.convertedUsername(f));
  }

  // v0.6.19 — 月份选择器改 monthSelect plugin (辉哥 9/28 14:35 拍板方案 A: 12 月网格 month-only)
  // 根因: v0.6.18 用 monthSelectorType dropdown 的 flatpickr 默认月视图, popover 弹出"日历视图
  //   (7 列 weekday + 月份下拉 + 年份输入)", 但用户诉求是"只选月份" — 看日历视图需要再点 1 次
  //   月份才是真"只选月份", UX 冗余. v0.6.18a 修复 arrow/iOS 重复 input 后, 辉哥拍板用 monthSelect plugin
  //   直接出 12 月网格 + 年份输入 + prev/next 三角, 不再有冗余日历视图.
  //   关键配置 (辉哥拍板) 现在下沉到 DatePickerHelper.mountDatePicker mode='month':
  //     - plugins: monthSelectPlugin({ shorthand: true, dateFormat: 'Y-m' })
  //     - disableMobile: true (v0.6.18a F2 修复保持)
  //     - appendTo: document.body (SOP 106)
  //     - onReady Math.max(inputWidth, 335) (SOP 107 兜底)
  //     - locale: zh fallback (跟 CalendarTab 同款)
  //   详细 SOP 注释见 utils/DatePickerHelper.js
  async initMonthPicker() {
    if (this._monthPickerFp) return; // 已初始化, 幂等
    const textInput = this.element && this.element.querySelector('.ZS-month-picker-input');
    if (!textInput) {
      this.retryMonthPicker(); // view() 加载态还没渲染 input
      return;
    }
    this._monthPickerFp = await mountDatePicker(textInput, {
      mode: 'month',
      defaultDate: this.selectedMonth + '-01',
      // '2026-10' + '-01' = '2026-10-01', monthSelect 接受 ISO 日期
      onChange: (selectedDates, dateStr) => {
        if (selectedDates.length > 0 || dateStr) {
          // dateStr 是 'YYYY-MM' (dateFormat: 'Y-m' 触发), 直接喂 sales-stats / sales-followups month param
          this.selectedMonth = dateStr;
          this.load(); // 同时刷 stats + followups
        }
      }
    });

    // vendor 未就绪 (helper 内部 waitForVendor 超时), 走 retry 兜底
    if (!this._monthPickerFp) {
      this.retryMonthPicker();
    }
  }

  // vendor flatpickr / input DOM 未就绪时重试 (上限 5s, 跟 BindCardModal polling 同套路, 防死循环)
  retryMonthPicker() {
    if (this._monthPickerTimer || this._monthPickerRetry >= 50) return;
    this._monthPickerTimer = setTimeout(() => {
      this._monthPickerTimer = null;
      this._monthPickerRetry++;
      this.initMonthPicker();
    }, 100);
  }

  // v0.6.19 — 月份选择器 (mobile + desktop 共用组件)
  //   mobile  (v3 B-view1 设计图): 标题 + flatpickr input 同一行 (卡片内), 说明文字在卡片下方
  //   desktop (v4 方案 C / v5 dark B): Pipeline 并排右侧 320px 卡, 标题在上 / input 撑满 / 说明在下
  //   v0.6.19 改 input value 直接用 'YYYY-MM' (跟 monthSelect dateFormat 'Y-m' 一致, 后端 month param 同款),
  //   popover = 12 月月网格 + 年份输入框 + prev/next 三角, 不受 8 个月限制.
  renderMonthPicker() {
    return m("div", {
      className: "ZS-month-picker"
    }, m("div", {
      className: "ZS-month-picker-row"
    }, m("span", {
      className: "ZS-month-picker-label"
    }, m("i", {
      className: "fas fa-calendar-days",
      style: "color:var(--zs-warning-f59e0b, #f59e0b);margin-right:6px;"
    }), "\u6570\u636E\u6708\u4EFD"), m("input", {
      className: "ZS-date-input-text ZS-month-picker-input",
      type: "text",
      value: this.selectedMonth
    })));
  }
  renderKpis() {
    const stats = this.salesStats?.kpis;
    const ct = stats?.customer_total;
    const cr = stats?.convert_rate;
    const mr = stats?.month_revenue;
    const pn = stats?.pending;
    return (
      /* v0.17.41 (辉哥 10/15 拍板) — 加 .ZS-stat-row-sales 专属 class。
       * v0.17.40 删掉第 5 张 demo 占位卡后本 tab 只剩 4 张, 而 .ZS-stat-row (LESS L498)
       * 是 `repeat(5, 1fr)` 的 5 列 grid ⇒ 桌面端右侧空出一整列。
       * ⚠️ 不能直接改 .ZS-stat-row: 学员列表 (StudentsListTab.js:542) 共用这个类,
       *    它的 className 是 `ZS-stat-row ZS-stat-row-desktop`, 5 张卡, 且
       *    .ZS-stat-row-desktop (LESS L3546) **只重定义 padding, 没有重定义列数**,
       *    5 列完全继承自 .ZS-stat-row —— 改基类会把学员列表挤成 4 列换行。
       *    故只给本 tab 加专属 class, 由 LESS 里 .ZS-stat-row-sales.ZS-stat-row
       *    (特异度 0,2,0 > 基类 0,1,0) 做**桌面段** 4 列覆盖。
       *    卡片内容 (label / value / 环比那行) 本轮一个字没动。 */
      m("div", {
        className: "ZS-stat-row ZS-stat-row-sales"
      }, m("div", {
        className: "ZS-stat-card"
      }, m("div", {
        className: "ZS-stat-icon"
      }, m("i", {
        className: "fas fa-user",
        style: "color:var(--zs-brand-3b82f6, #3b82f6);"
      })), m("div", null, m("div", {
        className: "ZS-stat-label"
      }, "\u5BA2\u6237\u603B\u6570"), m("div", {
        className: "ZS-stat-value"
      }, ct?.value ?? '—'), m("div", {
        style: "color:var(--zs-success-34c759, #34c759);font-size:12px;"
      }, ct?.week_new ?? '↑ 本周'))), m("div", {
        className: "ZS-stat-card"
      }, m("div", {
        className: "ZS-stat-icon",
        style: "background:var(--zs-success-soft-52-199-89-015, rgba(52,199,89,0.15));color:var(--zs-success-34c759, #34c759);"
      }, m("i", {
        className: "fas fa-check"
      })), m("div", null, m("div", {
        className: "ZS-stat-label"
      }, "\u8F6C\u5316\u7387"), m("div", {
        className: "ZS-stat-value"
      }, cr?.value ?? '—', m("span", {
        style: "font-size:13px;color:var(--zs-text-2-9ca3af, #9ca3af);"
      }, cr?.unit ?? '%')), cr?.change && m("div", {
        style: 'font-size:12px;color:' + (cr.up ? '#34c759' : 'var(--zs-danger-ff3b30, #ff3b30)') + ';margin-top:2px;'
      }, cr.up ? '↑' : '↓', " ", cr.change))), m("div", {
        className: "ZS-stat-card"
      }, m("div", {
        className: "ZS-stat-icon"
      }, m("i", {
        className: "fas fa-dollar-sign",
        style: "color:var(--zs-success-22c55e, #22c55e);"
      })), m("div", null, m("div", {
        className: "ZS-stat-label"
      }, "\u672C\u6708\u9500\u552E\u989D"), m("div", {
        className: "ZS-stat-value"
      }, mr?.value ?? '—'), mr?.change && m("div", {
        style: 'font-size:12px;color:' + (mr.up ? '#34c759' : 'var(--zs-danger-ff3b30, #ff3b30)') + ';margin-top:2px;'
      }, mr.up ? '↑' : '↓', " ", mr.change))), m("div", {
        className: "ZS-stat-card"
      }, m("div", {
        className: "ZS-stat-icon",
        style: "background:var(--zs-warning-soft-255-149-0-015, rgba(255,149,0,0.15));color:var(--zs-warning-ff9500, #ff9500);"
      }, m("i", {
        className: "fas fa-clipboard-list"
      })), m("div", null, m("div", {
        className: "ZS-stat-label"
      }, "\u5F85\u8DDF\u8FDB"), m("div", {
        className: "ZS-stat-value"
      }, pn?.value ?? '—', m("span", {
        style: "font-size:13px;color:var(--zs-text-2-9ca3af, #9ca3af);"
      }, pn?.unit ? ' ' + pn.unit : ' 人')), m("div", {
        style: "color:var(--zs-danger-ff3b30, #ff3b30);font-size:12px;"
      }, pn?.overdue ?? '0 已逾期'))))
    );
  }
  renderPipeline(isMobile) {
    // v0.6.17 — 用真实 API 数据 (本月 sales-stats.pipeline), 删 fallback `|| 52`
    const api = this.salesStats?.pipeline || {};
    const c = k => api[k] ?? 0;
    if (isMobile) {
      return m("div", {
        className: "ZS-pipeline"
      }, m("div", {
        className: "ZS-pipeline-header"
      }, m("div", {
        className: "ZS-pipeline-title"
      }, m("i", {
        className: "fas fa-bullseye",
        style: "color:var(--zs-cyan-06b6d4, #06b6d4);margin-right:6px;"
      }), "\u9500\u552E\u8F6C\u5316\u6F0F\u6597"), m("div", {
        className: "ZS-pipeline-sub"
      }, this.salesStats?.month || this.selectedMonth)), m("div", {
        className: "ZS-pipeline-stages"
      }, m("div", {
        className: "ZS-pipeline-stage"
      }, m("div", {
        className: "stage-num gray"
      }, c('potential')), m("div", {
        className: "stage-label"
      }, "\u6F5C\u5728")), m("div", {
        className: "ZS-pipeline-stage"
      }, m("div", {
        className: "stage-num blue"
      }, c('contacted')), m("div", {
        className: "stage-label"
      }, "\u5DF2\u8054\u7CFB")), m("div", {
        className: "ZS-pipeline-stage"
      }, m("div", {
        className: "stage-num cyan"
      }, c('booked')), m("div", {
        className: "stage-label"
      }, "\u5DF2\u7EA6\u8BFE")), m("div", {
        className: "ZS-pipeline-stage"
      }, m("div", {
        className: "stage-num orange"
      }, c('trial')), m("div", {
        className: "stage-label"
      }, "\u5DF2\u8BD5\u8BFE")), m("div", {
        className: "ZS-pipeline-stage"
      }, m("div", {
        className: "stage-num green"
      }, c('closed')), m("div", {
        className: "stage-label"
      }, "\u5DF2\u6210\u4EA4")), m("div", {
        className: "ZS-pipeline-stage"
      }, m("div", {
        className: "stage-num red"
      }, c('no_intent')), m("div", {
        className: "stage-label"
      }, "\u65E0\u610F\u5411"))));
    }
    // desktop fallback (stats API 还没返, 用 demo fallback)
    return m("div", {
      className: "ZS-funnel"
    }, m("div", {
      style: "display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;"
    }, m("h3", {
      style: "font-size:16px;font-weight:600;"
    }, m("i", {
      className: "fas fa-bullseye",
      style: "color:var(--zs-cyan-06b6d4, #06b6d4);margin-right:6px;"
    }), "\u9500\u552E\u8F6C\u5316\u6F0F\u6597"), m("span", {
      style: "font-size:13px;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u672C\u6708")), m("div", {
      className: "ZS-funnel-stages"
    }, m("div", {
      className: "ZS-funnel-stage"
    }, m("div", {
      className: "stage-num gray"
    }, c('potential')), m("div", {
      className: "stage-label"
    }, "\u6F5C\u5728\u5BA2\u6237")), m("div", {
      className: "ZS-funnel-stage"
    }, m("div", {
      className: "stage-num blue"
    }, c('contacted')), m("div", {
      className: "stage-label"
    }, "\u5DF2\u8054\u7CFB")), m("div", {
      className: "ZS-funnel-stage"
    }, m("div", {
      className: "stage-num cyan"
    }, c('booked')), m("div", {
      className: "stage-label"
    }, "\u5DF2\u7EA6\u8BFE")), m("div", {
      className: "ZS-funnel-stage"
    }, m("div", {
      className: "stage-num orange"
    }, c('trial')), m("div", {
      className: "stage-label"
    }, "\u5DF2\u8BD5\u8BFE")), m("div", {
      className: "ZS-funnel-stage"
    }, m("div", {
      className: "stage-num green"
    }, c('closed')), m("div", {
      className: "stage-label"
    }, "\u5DF2\u6210\u4EA4")), m("div", {
      className: "ZS-funnel-stage"
    }, m("div", {
      className: "stage-num red"
    }, c('no_intent')), m("div", {
      className: "stage-label"
    }, "\u65E0\u610F\u5411"))));
  }

  /**
   * v0.17.20 — 触底哨兵 + 「加载中 / 已全部加载」三条尾巴。
   *
   * ⚠️ 桌面表格与移动卡片是**两个**渲染器, 各渲染一次列表 —— 所以这两条尾巴
   *   也得在两个渲染器里各写一份。根视图只渲染其中一个, 但组件不会同时挂两棵树,
   *   所以不会重复。
   *
   * 只有 has_more 时才渲染 sentinel: 没有下一页就不该有哨兵,
   * 否则会一直触发无意义的请求 (syncObserver 也会再挡一道)。
   */
  renderListTail() {
    const meta = this.meta;
    const total = this.totalCount();
    // 「已全部加载」只在**真的翻过页**之后才显示:
    //   一屏装得下的月份 (比如 9 月只有 5 条) 根本没有滚动, 在那里加结束语是纯噪音。
    const showEnd = !!meta && !meta.has_more && this.paginatedOnce;
    return m("div", {
      className: "ZS-sales-tail"
    }, meta && meta.has_more && m("div", {
      className: "ZS-sales-sentinel",
      "data-zsalessid": this._sid,
      "aria-hidden": "true"
    }), this.loadingMore && m("div", {
      className: "ZS-sales-loading-more"
    }, m("i", {
      className: "fas fa-spinner fa-spin",
      "aria-hidden": "true"
    }), " \u6B63\u5728\u52A0\u8F7D\u2026"), showEnd && m("div", {
      className: "ZS-sales-end"
    }, "\u5DF2\u5168\u90E8\u52A0\u8F7D\uFF08\u5171 ", total, " \u6761\uFF09"));
  }

  /** v0.17.20 — 汇总行: 共 N 条 + 已加载 M 条。⚠️ 总数一律读 meta.total */
  renderSummary() {
    const meta = this.meta;
    if (this.loading || !meta) return null;
    const total = this.totalCount();
    return m("div", {
      className: "ZS-sales-summary"
    }, "\u5171 ", total, " \u6761", this.followups.length < total ? m("span", null, "\uFF08\u5DF2\u52A0\u8F7D ", this.followups.length, " \u6761\uFF0C\u7EE7\u7EED\u4E0B\u6ED1\u52A0\u8F7D\u66F4\u591A\uFF09") : null);
  }
  renderToolbar() {
    return (
      /* v0.7.x — 简化销售跟进 tab toolbar: 跟进记录(最左) + 新建跟进(最右), 砍 toolbar-left/right 子 div
       (不再 mobile-only 显示 + 新建跟进 button, 桌面 + 移动端都同行显示) */
      m("div", {
        className: "ZS-toolbar ZS-sales-toolbar"
      }, m("div", {
        style: "font-size:16px;font-weight:600;"
      }, m("i", {
        className: "fas fa-phone",
        style: "color:var(--zs-cyan-06b6d4, #06b6d4);margin-right:8px;"
      }), "\u8DDF\u8FDB\u8BB0\u5F55"), m("button", {
        className: "ZS-btn",
        onclick: () => this.openCreateFollowup()
      }, "+ \u65B0\u5EFA\u8DDF\u8FDB"))
    );
  }

  /* ── v0.16.11 移动端 · 方案 A「时间轴」 ──────────────────────────────
   *  骨架: 左侧 13px 竖线 + 圆点表紧迫度 → 右侧两到三行信息。
   *  信息层级: ① 客户名 + 渠道 + 阶段 + 下次跟进   ② 年龄/电话/经办人/教练
   *            ③ 跟进内容单行摘要 (省略号)。
   *  ⚠️ 三条硬规则:
   *    1. 空字段**整段不渲染** (不再 '—' 占位) —— 极简记录卡不能因为缺字段变高;
   *    2. 长文本必须 ellipsis, 不能硬切撑破卡片;
   *    3. 电话可点 tel:, 无号码时拨号键降级成灰色「无号码」。
   *  v0.16.8 只把「教练」加到了桌面表格, 移动端一直没跟上 —— 本轮补上。
   */
  renderFollowupCards() {
    const stop = e => {
      e.stopPropagation();
    };
    return m("div", {
      className: "ZS-sales-card-list"
    }, this.followups.map(f => {
      const sb = this.formatStage(f.stage);
      const ch = this.formatChannel(f.lead_channel_id, f.lead_channel_name);
      const custName = this.customerName(f);
      const isExpanded = this.expandedFollowups.has(f.id);
      const salesName = f.sales?.display_name || (f.sales ? `销售 #${f.sales.id}` : `销售 #${f.sales_id}`);
      const u = this.urgency(f);
      const age = this.ageText(f.age);
      const coach = this.coachText(f);
      const hasPhone = !this.isBlankVal(f.phone);
      const content = this.isBlankVal(f.content) ? null : f.content;
      const personal = this.isBlankVal(f.personal_note) ? null : f.personal_note;
      const cat = this.isBlankVal(f.lesson_category_name) ? null : f.lesson_category_name;

      // 第二行: 只渲染有值的字段, 空字段整段消失
      const bits = [];
      if (age !== null) bits.push({
        cls: 'age',
        text: `${age} 岁`,
        tel: false
      });
      if (hasPhone) bits.push({
        cls: 'tel',
        text: f.phone,
        tel: true
      });
      if (!this.isBlankVal(salesName) && salesName !== '—') bits.push({
        cls: 'sales',
        text: salesName,
        tel: false
      });
      if (coach !== null) bits.push({
        cls: 'coach',
        text: `教练 ${coach}`,
        tel: false
      });
      const metaLine = bits.map((b, i) => m("span", {
        key: b.cls
      }, i > 0 && m("span", {
        className: "dotsep"
      }, "\xB7"), b.tel ? m("a", {
        className: b.cls,
        href: `tel:${f.phone}`,
        onclick: stop
      }, b.text) : m("span", {
        className: b.cls
      }, b.text)));
      return m("div", {
        className: 'ZS-fc-card' + (isExpanded ? ' expanded' : ''),
        key: f.id,
        onclick: () => this.toggleFollowupExpand(f.id)
      }, m("div", {
        className: "ZS-fc-rail"
      }, m("div", {
        className: 'ZS-fc-dot ' + u.k
      })), m("div", {
        className: "ZS-fc-body"
      }, m("div", {
        className: "ZS-fc-row1"
      }, m("span", {
        className: "ZS-fc-student",
        title: custName
      }, custName), this.renderTrialBadge(f), this.renderOriginBadge(f), this.renderConvertedBadge(f), ch && m("span", {
        className: 'ZS-ch-tag ' + ch.class
      }, ch.label), !this.isMarkedStage(f) && m("span", {
        className: 'ZS-status-tag ' + sb.class
      }, sb.label), m("span", {
        className: 'ZS-fc-due u-' + u.k
      }, u.date && m("span", {
        className: "d"
      }, u.date), m("span", {
        className: "r"
      }, u.rel))), bits.length > 0 && m("div", {
        className: "ZS-fc-row2"
      }, m("div", {
        className: "ZS-fc-meta"
      }, metaLine), hasPhone ? m("a", {
        className: "ZS-fc-call",
        href: `tel:${f.phone}`,
        onclick: stop,
        "aria-label": `拨打 ${f.phone}`
      }, m("i", {
        className: "fas fa-phone"
      })) : m("span", {
        className: "ZS-fc-call mute",
        title: "\u8BE5\u8BB0\u5F55\u672A\u586B\u5199\u7535\u8BDD"
      }, "\u65E0\u53F7\u7801")), content && m("div", {
        className: "ZS-fc-note",
        title: content
      }, content), m("div", {
        className: 'ZS-fc-details' + (isExpanded ? ' expanded' : '')
      }, f.trial_count !== null && f.trial_count !== undefined && f.trial_count > 0 && m("div", {
        className: "ZS-fc-kv"
      }, m("span", {
        className: "k"
      }, "\u4F53\u9A8C\u6B21\u6570"), m("span", {
        className: "v"
      }, f.trial_count, " \u6B21", Number(f.trial_cancelled_count) > 0 ? `（含 ${Number(f.trial_cancelled_count)} 次已取消）` : '')), m("div", {
        className: "ZS-fc-kv"
      }, m("span", {
        className: "k"
      }, "\u8DDF\u8FDB\u65F6\u95F4"), m("span", {
        className: "v dim"
      }, (f.created_at || '').slice(0, 16).replace('T', ' ') || '—')), cat && m("div", {
        className: "ZS-fc-kv"
      }, m("span", {
        className: "k"
      }, "\u8BFE\u7A0B\u5206\u7C7B"), m("span", {
        className: "v"
      }, cat)), personal && m("div", {
        className: "ZS-fc-kv"
      }, m("span", {
        className: "k"
      }, "\u4E2A\u4EBA\u60C5\u51B5"), m("span", {
        className: "v dim long"
      }, personal)), content && m("div", {
        className: "ZS-fc-kv"
      }, m("span", {
        className: "k"
      }, "\u8DDF\u8FDB\u5185\u5BB9"), m("span", {
        className: "v dim long"
      }, content))), m("div", {
        className: 'ZS-fc-actions' + (isExpanded ? ' expanded' : '')
      }, this.renderConvertButtonMobile(f), this.renderTrialButtonMobile(f), !this.isMarkedStage(f) && m("button", {
        className: "ZS-fc-action",
        onclick: e => this.openBookingFromSales(e)
      }, m("i", {
        className: "fas fa-calendar-days"
      }), "\u9884\u7EA6"), this.isMarkedStage(f) ? m("button", {
        className: "ZS-fc-action",
        onclick: e => this.undoFollowupStage(f, e)
      }, m("i", {
        className: "fas fa-rotate-left"
      }), "\u53D6\u6D88\u6807\u8BB0") : m('[', null, m("button", {
        className: "ZS-fc-action",
        onclick: e => this.setFollowupStage(f, 'closed', e)
      }, m("i", {
        className: "fas fa-check"
      }), "\u6807\u8BB0\u6210\u4EA4"), m("button", {
        className: "ZS-fc-action danger",
        onclick: e => this.setFollowupStage(f, 'no_intent', e)
      }, m("i", {
        className: "fas fa-xmark"
      }), "\u6807\u8BB0\u6D41\u5931")))));
    }), this.followups.length === 0 && m("div", {
      style: "padding:40px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u6682\u65E0\u8DDF\u8FDB\u8BB0\u5F55"), this.renderListTail());
  }

  /* ── v0.16.11 桌面端 · 方案二「表格重构」 ────────────────────────────
   *  列序 (辉哥 10/11 拍板): 客户 | **下次跟进** | 年龄 | 电话 | 来源渠道 | 阶段 | 经办人 | 教练 | [跟进内容] | 操作
   *  「下次跟进」从最右列挪到第 2 列 —— 设计稿原本放在最右, 与「第一落点 =
   *  今天该找谁」直接冲突, 这是本轮必须改的一处结构改动。
   *
   *  ⚠️ 轨道数必须 == 该档可见单元数 (设计稿实测踩过的坑: 少写一轨 ⇒ 多出的
   *  cell 掉进隐式列, 隐式列是 auto 宽 ⇒ scrollWidth 被顶出去, 正是生产裁列的同款)。
   *  为根除这个坑, 行内包一层 .ZS-row-grid: grid 的直接子元素恒等于那 9 个
   *  cell 本身, 展开面板是它的**兄弟节点**而非 grid 子项, 不参与轨道数计算。
   *  轨道定义全部搬进 LESS (按容器宽度逐级下沉), 这里不再写 inline
   *  grid-template-columns —— inline style 压不住容器查询。
   */
  renderDesktopTable() {
    const stop = e => {
      e.stopPropagation();
    };
    return m("div", {
      className: "ZS-table ZS-table-customer"
    }, m("div", {
      className: "ZS-table-header"
    }, m("div", {
      className: "ZS-col-cust"
    }, "\u5BA2\u6237"), m("div", {
      className: "ZS-col-next"
    }, "\u4E0B\u6B21\u8DDF\u8FDB"), m("div", {
      className: "ZS-col-age ZS-h-center"
    }, "\u5E74\u9F84"), m("div", {
      className: "ZS-col-ph"
    }, "\u7535\u8BDD"), m("div", {
      className: "ZS-col-ch"
    }, "\u6765\u6E90\u6E20\u9053"), m("div", {
      className: "ZS-col-stage"
    }, "\u9636\u6BB5"), m("div", {
      className: "ZS-col-sales"
    }, "\u7ECF\u529E\u4EBA"), m("div", {
      className: "ZS-col-coach"
    }, "\u6559\u7EC3"), m("div", {
      className: "ZS-col-note"
    }, "\u8DDF\u8FDB\u5185\u5BB9"), m("div", {
      className: "ZS-col-acts ZS-h-right"
    }, "\u64CD\u4F5C")), this.followups.map(f => {
      const sb = this.formatStage(f.stage);
      const ch = this.formatChannel(f.lead_channel_id, f.lead_channel_name);
      const custName = this.customerName(f);
      const salesName = f.sales?.display_name || (f.sales ? `销售 #${f.sales.id}` : `销售 #${f.sales_id}`);
      const coach = this.coachText(f);
      const u = this.urgency(f);
      const age = this.ageText(f.age);
      const isExpanded = this.expandedFollowups.has(f.id);
      const hasPhone = !this.isBlankVal(f.phone);
      const content = this.isBlankVal(f.content) ? null : f.content;
      const personal = this.isBlankVal(f.personal_note) ? null : f.personal_note;
      const cat = this.isBlankVal(f.lesson_category_name) ? null : f.lesson_category_name;

      // 被下沉掉的列, 在展开详情里以 chip 补回 —— 信息一条不丢
      const folded = [];
      if (ch) folded.push({
        k: '来源渠道',
        v: ch.label
      });
      if (coach !== null) folded.push({
        k: '教练',
        v: coach
      });
      if (hasPhone) folded.push({
        k: '电话',
        v: f.phone
      });
      if (!this.isBlankVal(salesName) && salesName !== '—') folded.push({
        k: '经办人',
        v: salesName
      });
      if (age !== null) folded.push({
        k: '年龄',
        v: `${age} 岁`
      });
      return m("div", {
        className: 'ZS-table-row' + (isExpanded ? ' expanded' : ''),
        key: f.id,
        onclick: () => this.toggleFollowupExpand(f.id)
      }, m("div", {
        className: 'ZS-urg ' + u.k
      }), m("div", {
        className: "ZS-row-grid"
      }, m("div", {
        className: "ZS-col-cust ZS-cust-cell"
      }, m("span", {
        className: "ZS-cust-av"
      }, this.initial(custName)), m("span", {
        className: "ZS-cust-nm",
        title: custName
      }, custName), this.renderTrialBadge(f), this.renderOriginBadge(f), this.renderConvertedBadge(f)), m("div", {
        className: 'ZS-col-next ZS-next-cell u-' + u.k
      }, m("span", {
        className: "d"
      }, u.date || '未设'), m("span", {
        className: "r"
      }, u.rel)), m("div", {
        className: "ZS-col-age ZS-age-cell"
      }, age !== null ? age : ''), m("div", {
        className: "ZS-col-ph ZS-phone-cell"
      }, hasPhone && m("a", {
        className: "ZS-ph-link",
        href: `tel:${f.phone}`,
        onclick: stop
      }, f.phone)), m("div", {
        className: "ZS-col-ch"
      }, ch && m("span", {
        className: 'ZS-ch-tag ' + ch.class
      }, ch.label)), m("div", {
        className: "ZS-col-stage"
      }, !this.isMarkedStage(f) && m("span", {
        className: 'ZS-status-tag ' + sb.class
      }, sb.label)), m("div", {
        className: "ZS-col-sales ZS-pl-cell"
      }, salesName !== '—' ? salesName : ''), m("div", {
        className: "ZS-col-coach ZS-pl-cell"
      }, coach), m("div", {
        className: "ZS-col-note ZS-note-cell"
      }, content && m("span", {
        className: "note-in",
        title: content
      }, content)), m("div", {
        className: "ZS-col-acts"
      }, this.renderTrialButtonDesktop(f), m("button", {
        className: "ZS-acts-caret",
        "aria-label": "\u5C55\u5F00\u8BE6\u60C5",
        "aria-expanded": isExpanded ? 'true' : 'false',
        onclick: e => {
          e.stopPropagation();
          this.toggleFollowupExpand(f.id);
        }
      }, m("i", {
        className: "fas fa-caret-right"
      })))), isExpanded && m("div", {
        className: "ZS-row-detail",
        onclick: stop
      }, m("div", {
        className: "ZS-folded"
      }, folded.length > 0 ? folded.map(x => m("span", {
        className: "fi",
        key: x.k
      }, m("em", null, x.k), m("b", null, x.v))) : m("span", {
        className: "fi dim"
      }, "\u8BE5\u8BB0\u5F55\u672A\u586B \u6E20\u9053 / \u6559\u7EC3 / \u7535\u8BDD / \u7ECF\u529E\u4EBA / \u5E74\u9F84")), m("div", {
        className: "ZS-dgrid"
      }, m("div", {
        className: "ZS-dfield"
      }, m("div", {
        className: "dl"
      }, "\u8DDF\u8FDB\u65F6\u95F4"), m("div", {
        className: "dv"
      }, (f.created_at || '').slice(0, 16).replace('T', ' '))), m("div", {
        className: "ZS-dfield"
      }, m("div", {
        className: "dl"
      }, "\u8BFE\u7A0B\u5206\u7C7B"), m("div", {
        className: 'dv' + (cat ? '' : ' dim')
      }, cat || '未填写')), m("div", {
        className: "ZS-dfield wide"
      }, m("div", {
        className: "dl"
      }, "\u4E2A\u4EBA\u60C5\u51B5"), personal ? m("div", {
        className: "long",
        title: personal
      }, personal) : m("div", {
        className: "dv dim"
      }, "\u672A\u586B\u5199")), m("div", {
        className: "ZS-dfield wide"
      }, m("div", {
        className: "dl"
      }, "\u8DDF\u8FDB\u5185\u5BB9"), content ? m("div", {
        className: "long",
        title: content
      }, content) : m("div", {
        className: "dv dim"
      }, "\u672A\u586B\u5199"))), m("div", {
        className: "ZS-dacts"
      }, this.renderConvertButtonDesktop(f), !this.isMarkedStage(f) && m("button", {
        className: "a-book",
        onclick: e => this.openBookingFromSales(e)
      }, m("i", {
        className: "fas fa-calendar-days"
      }), "\u9884\u7EA6"), this.isMarkedStage(f) ? m("button", {
        className: "a-undo",
        onclick: e => this.undoFollowupStage(f, e)
      }, m("i", {
        className: "fas fa-rotate-left"
      }), "\u53D6\u6D88\u6807\u8BB0") : m('[', null, m("button", {
        className: "a-win",
        onclick: e => this.setFollowupStage(f, 'closed', e)
      }, m("i", {
        className: "fas fa-check"
      }), "\u6807\u8BB0\u6210\u4EA4"), m("button", {
        className: "a-lose",
        onclick: e => this.setFollowupStage(f, 'no_intent', e)
      }, m("i", {
        className: "fas fa-xmark"
      }), "\u6807\u8BB0\u6D41\u5931")))));
    }), this.followups.length === 0 && m("div", {
      style: "padding:40px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
    }, "\u6682\u65E0\u8DDF\u8FDB\u8BB0\u5F55 \u2014 \u663E\u793A demo \u6F0F\u6597\u6570\u636E"), this.renderListTail());
  }
  view() {
    const isMobile = this.isMobile();
    if (this.loading && !this.salesStats) {
      return m("div", {
        style: "padding:60px;text-align:center;color:var(--zs-text-2-9ca3af, #9ca3af);"
      }, "\u52A0\u8F7D\u4E2D...");
    }
    return m("div", null, isMobile && this.renderMonthPicker(), this.renderDataPanel(), isMobile ? null : m("div", {
      className: "ZS-pipeline-side"
    }, this.renderPipeline(false), this.renderMonthPicker()), this.renderToolbar(), m("div", {
      style: "height:12px"
    }), this.renderSummary(), isMobile ? this.renderFollowupCards() : this.renderDesktopTable());
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/components/SalesTab', SalesTab);